import { render, staticRenderFns } from "./AddVendorPopup.vue?vue&type=template&id=5d878429"
import script from "./AddVendorPopup.vue?vue&type=script&lang=js"
export * from "./AddVendorPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports